import { css } from 'twind/css'

export const audioVisualizerText = css({
  fontSize: '18px',
  lineHeight: '102px',
  color: 'var(--white)',
  zIndex: 1,
})

export const audioVisualizerTextWrapper = css({
  backgroundColor: 'var(--gray3)',
})
